module.exports = __webpack_public_path__ + "img/engraving-2.637cd47.webp";